import { jsx } from "react/jsx-runtime";
import { Box, TextButton } from "@zillow/constellation";
import { yieldCallback } from "@zillow/yield-callback";
import "react";
import { getCmsInfoForPage } from "../../utils/clickstream/getCmsInfoForPage.esm.js";
import { usePageProps } from "../PagePropsProvider/PagePropsProvider.esm.js";
import { sendEvent } from "./B2BMainNav.utils.esm.js";
import MenuList from "./MenuList.esm.js";
const DropdownMenuItem = ({
  item,
  sx
}) => {
  const pageProps = usePageProps();
  const cmsInfo = getCmsInfoForPage(pageProps);
  const handleItemClick = (item2) => {
    sendEvent("cms_anchor", item2.label, item2.url, cmsInfo);
  };
  return /* @__PURE__ */ jsx(Box, { as: "li", sx: {
    fontFamily: "$fonts.sansSerif",
    lineHeight: "$lineHeights.body",
    ...sx
  }, children: /* @__PURE__ */ jsx(TextButton, { as: "a", fontType: "bodySmall", href: item.url, target: item.target, rel: item.target === "_blank" ? "noopener noreferrer" : void 0, onClick: yieldCallback(() => {
    handleItemClick(item);
  }), children: item.label }) });
};
const Dropdown = ({
  submenus,
  dropdown
}) => {
  return /* @__PURE__ */ jsx(MenuList, { sx: {
    display: dropdown ? "block" : "none",
    fontSize: "$fontSizes.body",
    fontWeight: "$fontWeights.body",
    paddingInlineStart: "0",
    "@media $xl": {
      backgroundColor: "$colors.backgroundWhite",
      borderRadius: "$radii.md",
      boxShadow: "$shadows.shadow200",
      minWidth: "calc($spacing.md * 10)",
      overflow: "hidden",
      position: "absolute",
      top: "100%"
    },
    "@media $lg_lte": {
      backgroundColor: "$colors.backgroundLight",
      borderTop: "solid 1px $colors.borderLight",
      padding: "$spacing.xs 0",
      position: "relative",
      width: "100%"
    }
  }, children: submenus.map((submenu, index) => /* @__PURE__ */ jsx(DropdownMenuItem, { item: submenu, sx: {
    padding: "$spacing.xs $spacing.sm",
    ":hover, :focus": {
      color: "$colors.textDark",
      backgroundColor: "$colors.backgroundBlue"
    }
  } }, index)) });
};
export {
  Dropdown as default
};
